import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../images/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { currentUser } = useAuth();
  const location = useLocation();
  
  // Hide navbar on the status page to make QR code scan result cleaner
  if (location.pathname.startsWith('/status/')) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="AntifurtQR Logo" className="logo-image" />
        </Link>
        
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          <span className={menuOpen ? 'icon-close' : 'icon-menu'}></span>
        </div>
        
        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          </li>
          
          {currentUser ? (
            <>
              <li className="nav-item">
                <Link 
                  to="/dashboard" 
                  className={location.pathname === '/dashboard' ? 'nav-link active' : 'nav-link'}
                  onClick={() => setMenuOpen(false)}
                >
                  Dashboard
                </Link>
              </li>
              <li className="nav-item user-info">
                <span className="user-email">{currentUser.email}</span>
              </li>
            </>
          ) : (
            <>
              <li className="nav-item">
                <Link 
                  to="/login" 
                  className={location.pathname === '/login' ? 'nav-link active' : 'nav-link'}
                  onClick={() => setMenuOpen(false)}
                >
                  Login
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  to="/register" 
                  className={`nav-link register ${location.pathname === '/register' ? 'active' : ''}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Register
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;